// Sizes in px
export const sizes = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
  xxl: 72,
  xxxl: 80,
};

// Spaces in px
export const spaces = {
  sm: 16,
  md: 24,
  lg: 32,
  lg: 48,
};
